import { z } from 'zod';
import { employmentApi } from '../../../api';
import { EMPLOYMENT_EVENT_TYPES } from '../../../../constants/employmentEventTypes';
import { EVENT_ACTOR_TYPES } from '../../../../constants/employmentActorTypes';
import { employmentEpisodeIdSchema } from '../episodeAddress';

/**
 * Validation schema for start delay
 */
const startDelayedSchema = z.object({
  employeeId: z.uuid(),
  employmentEpisodeId: employmentEpisodeIdSchema, // ADR-155 §6
  newStartDate: z.iso.date('New start date must be in ISO format (YYYY-MM-DD)'),
  reason: z.string().min(1, 'Reason is required')
});

/**
 * Delay Employee Start Date
 *
 * Updates the start date for a pending hire (before they start).
 *
 * @param {Object} payload - Start delay data
 * @param {string} payload.employeeId - Required
 * @param {string} payload.newStartDate - Required - ISO date format (YYYY-MM-DD), must be in future
 * @param {string} payload.reason - Required
 * @param {string} [actorType='User'] - Actor type (System, User, Import)
 * @returns {Promise<Object>}
 * @throws {z.ZodError} - If validation fails
 */
export const startDelayed = async (payload, actorType = EVENT_ACTOR_TYPES.USER) => {
  // Validate payload
  const validatedPayload = startDelayedSchema.parse(payload);

  return await employmentApi.triggerEmploymentEvents({
    metadata: {
      actorType
    },
    events: [{
      type: EMPLOYMENT_EVENT_TYPES.START_DELAYED,
      payload: validatedPayload
    }]
  });
};
